/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import type { GetStudyPaymentApprovalThresholdsResponse } from '../models/GetStudyPaymentApprovalThresholdsResponse';
import type { SaveStudyPaymentApprovalThresholdsRequest } from '../models/SaveStudyPaymentApprovalThresholdsRequest';
import type { SaveStudyPaymentApprovalThresholdsResponse } from '../models/SaveStudyPaymentApprovalThresholdsResponse';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
@Injectable({
    providedIn: 'root',
})
export class StudyPaymentApprovalThresholdControllerV2Service {
    constructor(public readonly http: HttpClient) {}
    /**
     * @param studyId
     * @returns GetStudyPaymentApprovalThresholdsResponse
     * @throws ApiError
     */
    public studyPaymentApprovalThresholdControllerV2GetThresholds(
        studyId: number,
    ): Observable<GetStudyPaymentApprovalThresholdsResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/v2/studies/{studyId}/payment-approval-thresholds',
            path: {
                'studyId': studyId,
            },
        });
    }
    /**
     * @param studyId
     * @param requestBody
     * @returns SaveStudyPaymentApprovalThresholdsResponse
     * @throws ApiError
     */
    public studyPaymentApprovalThresholdControllerV2SaveThresholds(
        studyId: number,
        requestBody: SaveStudyPaymentApprovalThresholdsRequest,
    ): Observable<SaveStudyPaymentApprovalThresholdsResponse> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/v2/studies/{studyId}/payment-approval-thresholds',
            path: {
                'studyId': studyId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
